import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Chip from '@mui/material/Chip';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import Typography from '@mui/material/Typography';
import './CustomChip.sass'

const CustomChip = (props) => {
    const { t } = useTranslation();
    const { label, onDelete, chipType, filterLabel, valueLabel } = props;

    const handleDelete = () => {
        onDelete(filterLabel, t(valueLabel));
    }

    return (
        <div data-testid={`${filterLabel}-${valueLabel}`}>
            <Chip
                label={<div className='chipLabel'>
                    <Typography variant='h6'>{label}</Typography>
                    &nbsp;-&nbsp;
                    <Typography variant='h6' className='chipValueLabel'>{t(valueLabel)}</Typography>
                </div>}
                onDelete={handleDelete}
                className={chipType}
                deleteIcon={<ClearRoundedIcon data-testid={valueLabel} />}
            />
        </div>
    )
}

CustomChip.propTypes = {
    label: PropTypes.string,
    chipType: PropTypes.oneOf([
        "primary"
    ])
}

CustomChip.defaultProps = {
    chipType: "primary"
}

export default CustomChip